import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';

import { Uri } from '#constants/uri';

import type { ActionExecuteRequest } from './types/action-execute-request.type';
import type { ActionExecuteResponse } from './types/action-execute-response.type';

/**
 * Enqueues an action for asynchronous execution via the HSP.Enterprise actions endpoint.
 *
 * @param instance - The KyInstance used to make the HTTP request.
 * @param request - The request body containing the action and optional entity identifiers.
 * @returns A promise that resolves to an {@link ActionExecuteResponse} containing the new proc_trigger identifier.
 * @throws Will throw an error if the HTTP request fails.
 */
export const actionExecute = async (
  instance: KyInstance,
  request: ActionExecuteRequest
): Promise<ActionExecuteResponse> => {
  try {
    return await instance
      .post<ActionExecuteResponse>(Uri.action.execute, {
        json: request,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
